import { NextPageContext } from 'next'
import Error from 'next/error'
import React from 'react'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const Page = ({ statusCode }: { statusCode: Response['status'] }) => {
  return <Error statusCode={statusCode} />
}

Page.getInitialProps = ({ res, err }: NextPageContext) => {
  const statusCode = res?.statusCode || err?.statusCode || 404
  return { statusCode }
}

export default Page
